import { Button, makeStyles, Tooltip } from "@fluentui/react-components";
import { ICallToAction } from "./IHeroProps";
import { dolphinTokens } from "../../utils/Theme";
import { Link } from "react-router-dom";

interface ICallToActionProps {
    cta: ICallToAction;
}

interface ICallsToActionProps {
    primaryCta?: ICallToAction;
    secondaryCta?: ICallToAction;
}

const useStyles = makeStyles({
    buttonGroup: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "1rem",
        "@media (max-width: 768px)": {
            flexDirection: "column",
            alignItems: "stretch",
            gap: "0.75rem"
        }
    },
    ctaLink: {
        textDecoration: "none"
    },
    ctaButton: {
        backgroundColor: 'white !important',
        color: dolphinTokens.colorDarkBlue,
        padding: '1rem 1.5rem !important',
        fontWeight: '600 !important',
        borderRadius: '0.5rem !important',
        border: 'none !important',
        cursor: 'pointer !important',
        transition: 'transform 0.2s ease, color 0.2s ease, background-color 0.2s ease !important',
        marginTop: "1.5rem !important",
        fontSize: '1rem !important',

        '&:hover': {
            transform: 'translateY(-3px) !important',
            color: dolphinTokens.colorDarkBlue60,
        },

        '&:active': {
            color: `${dolphinTokens.colorLightBlue} !important`,
        },

        "@media (max-width: 768px)": {
            width: "100% !important"
        }
    },
    secondaryLink: {
        textDecoration: "none"
    },
    secondaryButton: {
        color: "white !important",
        padding: '1rem 1.5rem !important',
        fontWeight: '600 !important',
        borderRadius: '0.5rem !important',
        cursor: 'pointer !important',
        transition: 'transform 0.2s ease, color 0.2s ease, background-color 0.2s ease !important',
        marginTop: "1.5rem !important",
        fontSize: '1rem !important',

        '&:hover': {
            transform: 'translateY(-3px) !important',
        },

        '&:active': {
            backgroundColor: "white !important",
            color: `${dolphinTokens.colorLightBlue} !important`,
        },
    },
});

const PrimaryCallToAction = (props: ICallToActionProps) => {
    const { cta } = props;
    const styles = useStyles();

    return (
        <Link to={cta?.url} className={styles.ctaLink}>
            <Button type="button" appearance="primary" className={styles.ctaButton}>
                {cta?.text}
            </Button>
        </Link>
    );
};

const SecondaryCallToAction = (props: ICallToActionProps) => {
    const { cta } = props;
    const styles = useStyles();

    if (!cta.tooltip) {
        return (
            <Link to={cta?.url} className={styles.secondaryLink}>
                <Button appearance="outline" className={styles.secondaryButton}>
                    {cta?.text}
                </Button>
            </Link>
        );
    }

    return (
        <Tooltip content={cta.tooltip} relationship="label">
            <Link to={cta?.url} className={styles.secondaryLink}>
                <Button appearance="outline" className={styles.secondaryButton}>
                    {cta?.text}
                </Button>
            </Link>
        </Tooltip>
    );
};

const CallsToAction = (props: ICallsToActionProps) => {
    const { primaryCta, secondaryCta } = props;
    const styles = useStyles();

    return (
        <div className={styles.buttonGroup}>
            {
                primaryCta &&
                <PrimaryCallToAction cta={primaryCta} />
            }
            {
                secondaryCta &&
                <SecondaryCallToAction cta={secondaryCta} />
            }
        </div>
    );
}

export default CallsToAction;